module.exports = __webpack_public_path__ + "img/sandoghche_ganj.609ec8d7.png";